import React, { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  const show = useCallback((message, severity = 'success') => {
    setNotification({ open: true, message, severity });
  }, []);

  const showSuccess = useCallback((message) => show(message, 'success'), [show]);
  const showError = useCallback((message) => show(message, 'error'), [show]);
  const showWarning = useCallback((message) => show(message, 'warning'), [show]);
  const showInfo = useCallback((message) => show(message, 'info'), [show]);

  const handleClose = useCallback((event, reason) => {
    if (reason === 'clickaway') return;
    setNotification((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <NotificationContext.Provider value={{ showSuccess, showError, showWarning, showInfo }}>
      {children}
      <Snackbar open={notification.open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={notification.severity} variant="filled" sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}
